import {Component, KeyValueDiffers, OnInit} from '@angular/core';
import {DataSharingService} from '../../iBoxx/services/data-sharing.service';
import {LoaderService} from '../../iBoxx/shared/loader/loader-service.services';
import {ApiService} from '../../iBoxx/services/api.service';
import {UtilService} from '../../iBoxx/services/UtilService';
import {Router} from '@angular/router';
import {RangeDateScreenerFilterModel} from '../../iBoxx/modals/RangeDateScreenerFilterModel';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import { DoCheck } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-carbon-index-detail-page',
  templateUrl: './carbon-index-detail-page.component.html',
  styleUrls: ['./carbon-index-detail-page.component.scss']
})
export class CarbonIndexDetailPageComponent implements OnInit, DoCheck, AfterViewInit {

  tabList: string[] = [];
  currentTab = '';
  currentID = '';
  constituentDataLoaded = false;
  response: any = undefined;
  chartSetting = 'default';
  currentPeriod = 'YTD';
  currentTimeSeries = '';
  chartData = {
    chartSeries: {
      data: [],
      max: null,
      min: null,
      name: this.currentTimeSeries,
      unit: null},
    selectedPeriod: '',
    selectedTimeSeries: ''};
  constituentData: any;
  chartDataLoaded = false;
  chartDataFetching = false;
  dateRange: RangeDateScreenerFilterModel = new RangeDateScreenerFilterModel();
  periodData = ['YTD', '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y'];
  period: any;
  timeSeriesData = ['Total Return Index Level'];
  timeSeries: any;
  cards = ['CHART', 'INDEX PERFORMANCE & ANALYTICS', 'CONSTITUENT'];
  visibleCards = ['chart', 'analytics', 'constituent'];

  storedPeriod = '';
  storedTimeSeries = '';
  storedFromDate = '';
  storedToDate = '';

  expanded = false;
  currentCard = '';
  currentView = [];

  // ALERT VIEW
  showAlert1 = false;
  showAlert2 = false;
  showAlert3 = false;
  alert1 = '';
  alert2 = '';
  alert3 = '';
  alertType = 'info';
  indexNotInHeadline = false;
  indexNotFoundMsg = 'Invalid Request.';
  differ: any;


  constructor(private shareService: DataSharingService, private loader: LoaderService, private apiService: ApiService,
              public utilService: UtilService, private route: Router, private differs: KeyValueDiffers, private cdRef: ChangeDetectorRef) {
    this.differ = this.differs.find({}).create();
    this.initialiseDropDown();
    // @ts-ignore
    this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) ? JSON.parse(window.sessionStorage.getItem('tabListForCarbon')) :
      ['home', 'documentation'];
  }

  ngOnInit(): void {
    const urlSub = this.shareService.indexURL.subscribe((resp: any) => {
      if (this.isValidIndex(resp.split('=')[1])) {
        this.currentID = resp.split('=')[1];
        this.getChartOptionsFor(resp.split('=')[1]);
        this.fetchDetailsForID(resp.split('=')[1]);
      }else{
        this.indexNotInHeadline = true;
        this.loader.hide();
      }
    });
    if (urlSub) {
      urlSub.unsubscribe();
    }
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.chartData);
    if (change){
      this.chartDataLoaded = false;
      const elem = document.getElementsByClassName('no-data-display')[0];
      if (elem) {
        elem.remove();
      }
      setTimeout(() => {this.chartDataLoaded = true; }, 500);
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }


  initialiseDropDown(): void {
    this.period = {
      label: '',
      options: []
    };
    this.timeSeries = {
      label: '',
      options: []
    };
  }

  initDropDown(): void {
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: false
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: pd === (this.storedPeriod ? this.storedPeriod : 'YTD')
      });
    });

    this.timeSeriesData.forEach((ts: string) => {
      this.timeSeries.options.push({
        label: ts,
        value: ts,
        selected: ts === (this.storedTimeSeries ? this.storedTimeSeries : this.timeSeriesData[0])
      });
    });
    if (!this.currentID.includes('CCA') && !this.currentID.includes('EUA')){
      this.timeSeries.options.push({
        label: 'Weighted Carbon Price',
        value: 'Weighted Carbon Price',
        selected: this.storedTimeSeries === 'Weighted Carbon Price'
      });
    }
  }

  isValidIndex(identifier: string): boolean{
    const carbonIDs = ['GLCARB', 'GLCUCITS', 'GLCCCA', 'GLCEUA'];
    return carbonIDs.includes(identifier);
  }

  getIndexValue(index: string): void {
    this.currentTab = index;
    this.expanded = false;
    if (index === 'home') {
      this.route.navigateByUrl('Carbon/Home');
    } else if (index === 'documentation') {
      this.route.navigateByUrl('Indices/docs/page?docFor=Carbon');
    } else {
      this.repopulateView();
      window.location.href = window.location.href.split('=')[0] + '=' + index.split(' : ')[0];
    }
  }

  applyPeriodFilter(): void {
    this.currentPeriod = this.period.options.find((option: any) => {
      if (option.selected) {
        return option;
      }
    }).label;
    if (this.currentPeriod === 'No period selected'){
      if (!this.dateRange.ngbFromDate && !this.dateRange.ngbToDate){
        this.removeChart();
      }else{
        this.currentPeriod = 'custom';
      }
    }
    if (this.currentID.length > 0 && this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected') {
      this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
      this.storeChartOptionFor(this.currentID, '', '');
    }
  }

  applyTimeSeriesFilter(): void {
    this.currentTimeSeries = this.timeSeries.options.find((option: any) => {
      if (option.selected) {
        return option;
      }
    }).label;
    this.chartSetting = this.currentTimeSeries === 'Total Return Index Level' ? 'default' : 'custom';
    let from = '';
    let to = '';
    if (this.dateRange.ngbFromDate && this.dateRange.ngbFromDate) {
      // @ts-ignore
      from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
    }

    if (this.currentPeriod === 'custom' || this.currentPeriod === 'No period selected') {
      this.loader.show();
      this.loader.show();
      this.fetchCustomChartDataFor(from, to);
    } else {
      if (this.currentID.length > 0) {
        this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
      }
    }
    this.storeChartOptionFor(this.currentID, from, to);
  }

  setDateRange(event: any): void{
    this.currentPeriod = 'custom';
    if (event.ngbFromDate && event.ngbToDate){
      const from = event.ngbFromDate.month + '/' + event.ngbFromDate.day + '/' + event.ngbFromDate.year;
      const to = event.ngbToDate.month + '/' + event.ngbToDate.day + '/' + event.ngbToDate.year;
      const maxDate = event.maxDate.month + '/' + event.maxDate.day + '/' + event.maxDate.year;
      const minDate = event.minDate.month + '/' + event.minDate.day + '/' + event.minDate.year;
      if (!isNaN(new Date(from).getTime()) && !isNaN(new Date(to).getTime())
        && (new Date(from).getTime() >= new Date(minDate).getTime())
        && (new Date(to).getTime() <= new Date(maxDate).getTime())) {
        this.loader.show();
        this.storeChartOptionFor(this.currentID, from, to);
        this.reinitialisePeriodPicker();
        this.fetchCustomChartDataFor(from, to);
      }
    }
  }

  reinitialisePeriodPicker(): void {
    this.period = {
      label: '',
      options: []
    };
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: true
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: false
      });
    });
  }

  storeView(): void {
    const tabDetails = {
      tabName: this.currentTab,
      state: {
        visibleCards: this.visibleCards,
        expanded: this.expanded
      }
    };
    const index = this.currentView.findIndex((view: any) => view.tabName === tabDetails.tabName);
    if (index > -1) {
      // @ts-ignore
      this.currentView.splice(index, 1, tabDetails);
    } else {
      // @ts-ignore
      this.currentView.push(tabDetails);
    }
    localStorage.setItem('tabViewStateForCarbon', JSON.stringify(this.currentView));
  }

  expandView(cardName: string): void {
    if (this.expanded) {
      this.expanded = false;
      this.visibleCards = ['chart', 'analytics', 'constituent'];
    } else {
      this.expanded = true;
      this.currentCard = cardName;
      this.changeView(cardName);
    }
    this.storeView();
  }

  changeView(event: any): void {
    this.visibleCards.splice(0);
    switch (event) {
      case 'CHART':
        this.visibleCards.push('chart');
        break;
      case 'INDEX PERFORMANCE & ANALYTICS':
        this.visibleCards.push('analytics');
        break;
      case 'CONSTITUENT':
        this.visibleCards.push('constituent');
        break;
    }
    this.storeView();
  }

  repopulateView(): void {
    // @ts-ignore
    JSON.parse(localStorage.getItem('tabViewStateForCarbon')).forEach((view: any) => {
      if (view.tabName === this.currentTab) {
        this.visibleCards = view.state.visibleCards;
        if (this.visibleCards.length === 1) {
          // @ts-ignore
          this.currentCard = this.cards.find((card: string) => {
            if (card.includes(this.visibleCards[0].toUpperCase())) {
              return card;
            }
          });
        }
        if (!this.currentCard) {
          this.currentCard = 'CONSTITUENT';
        }
        this.expanded = view.state.expanded;
      }
    });
    this.chartDataLoaded = false;
    if (this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected') {
      this.dateRange = new RangeDateScreenerFilterModel();
    }
  }

  storeChartOptionFor(carbonID: string, fromDate: string, toDate: string): void{
    const options = {
      id: carbonID,
      periodType: this.currentPeriod === 'No period selected' ? 'custom' : this.currentPeriod,
      timeSeries: this.currentTimeSeries,
      fromDate,
      toDate
    };
    // @ts-ignore
    const filtersValue = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];
    const index = filtersValue.findIndex((filter: any) => filter.id === carbonID);
    if (index > -1) {
      filtersValue.splice(index, 1, options);
    } else {
      filtersValue.push(options);
    }
    localStorage.setItem('chartFilterOptions', JSON.stringify(filtersValue));
  }

  getChartOptionsFor(carbonID: string): void{
    this.currentID = carbonID;
    // @ts-ignore
    const filtersValue = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];
    const filter = filtersValue.find((value: any) => value.id === carbonID);
    if (filter) {
      this.storedFromDate = filter.fromDate;
      this.storedToDate = filter.toDate;
      this.storedPeriod = filter.periodType;
      this.storedTimeSeries = filter.timeSeries;
      this.currentPeriod = filter.periodType;
      this.currentTimeSeries = filter.timeSeries;
    }
    this.initialiseDropDown();
    this.initDropDown();
  }

  fetchDetailsForID(identifier: string): void {
    this.currentID = identifier;
    this.loader.show();
    this.apiService.getCarbonIndexDetailsFor(identifier).subscribe((resp: any) => {
      this.response = resp[0];
      this.currentTab = resp[0].id + ' : ' + resp[0].indexName;
      if (!this.tabList.includes(this.currentTab)) {
        this.tabList.push(this.currentTab);
        window.sessionStorage.setItem('tabListForCarbon', this.currentTab);
      }
      this.storeView();
    });
    if (this.storedPeriod !== '' && this.storedTimeSeries !== ''){
      if (this.storedPeriod === 'custom'){
        this.dateRange.ngbFromDate = new NgbDate(new Date(this.storedFromDate).getFullYear(),
          new Date(this.storedFromDate).getMonth() + 1, new Date(this.storedFromDate).getDate());
        this.dateRange.ngbToDate = new NgbDate(new Date(this.storedToDate).getFullYear(),
          new Date(this.storedToDate).getMonth() + 1, new Date(this.storedToDate).getDate());
        this.reinitialisePeriodPicker();
        this.currentPeriod = this.storedPeriod;
        this.fetchCustomChartDataFor(this.storedFromDate, this.storedToDate);
      }else{
        this.fetchChartDataFor(identifier, this.storedPeriod, this.storedTimeSeries);
      }
    }else {
      this.fetchChartDataFor(identifier, this.currentPeriod, this.timeSeriesData[0]);
    }
    this.fetchConstituentDataFor(identifier);
  }

  fetchChartDataFor(indexID: string, period: string, timeSeries: string): void {
    if (!this.chartDataFetching) {
      this.chartDataFetching = true;
      this.chartDataLoaded = false;
      this.loader.show();
      if (period === 'No period selected') {
        this.removeChart();
      } else {
        this.chartSetting = period === 'YTD' && timeSeries === 'Total Return Index Level' ? 'default' : 'custom';
        this.apiService.getChartDataForCarbonIndexFor(indexID, period,
          timeSeries).subscribe((resp: any) => {
          if (resp.error) {
            this.showAlert2 = true;
            this.alert2 = resp.errorMessage;
          } else {
            this.chartData = resp.chartData;
            this.chartDataLoaded = true;
            this.chartDataFetching = false;
            this.dateRange = new RangeDateScreenerFilterModel();
          }
          this.loader.hide();
        });
      }
    }
  }

  fetchCustomChartDataFor(from: string, to: string): void {
    this.chartDataLoaded = false;
    this.chartDataFetching = true;
    this.chartSetting = 'custom';
    this.loader.show();
    this.apiService.getCustomChartDataForCarbonIndexFor(this.currentID, from, to, this.currentTimeSeries)
      .subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert2 = true;
        this.alert2 = resp.errorMessage;
      } else {
        this.chartData = resp.chartData;
        this.chartDataLoaded = true;
        this.chartDataFetching = false;
      }
      this.loader.hide();
    });
  }

  resetChart(): void{
    this.chartSetting = 'default';
    this.currentPeriod = 'YTD';
    this.storedPeriod = 'YTD';
    this.currentTimeSeries = 'Total Return Index Level';
    this.storedTimeSeries = 'Total Return Index Level';
    this.initialiseDropDown();
    this.initDropDown();
    this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
    this.storeChartOptionFor(this.currentID, '', '');
  }

  removeChart(): void{
    setTimeout(() => {
      if (this.chartData) {
        this.chartData.chartSeries.data = [];
        this.chartData.chartSeries.name = this.currentTimeSeries;
        this.chartDataLoaded = false;
      }
      this.chartDataFetching = false;
      this.loader.hide();
    }, 1000);
  }

  fetchConstituentDataFor(indexID: string): void{
    this.constituentDataLoaded = false;
    this.loader.show();
    this.apiService.getConstituentDataForCarbon(indexID).subscribe((resp: any) => {
      this.constituentData = resp;
      this.constituentDataLoaded = true;
      this.loader.hide();
    });
  }

  downloadHistory(): void {
    this.loader.show();
    if (this.currentPeriod === 'No period selected'){
      this.downloadAsCSV(this.currentTimeSeries);
      this.loader.hide();
    }else if (this.currentPeriod === 'custom'){
      // @ts-ignore
      const from = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      const to = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
      this.apiService.getDataToDownloadForCustomForCarbon(this.currentID, from, to, this.currentTimeSeries,
        this.getFileName(this.currentTimeSeries));
      this.loader.hide();
    }else {
      this.apiService.getDataToDownloadForCarbon(this.currentID, this.currentPeriod, this.currentTimeSeries,
        this.getFileName(this.currentTimeSeries));
      this.loader.hide();
    }
  }

  downloadAsCSV(currentTimeSeries: string): void{
    // const headerList = ['Date', 'ISIN', 'Name', currentTimeSeries];
    // const dataToExport = this.utilService.convertToCSV(this.response.isinTri, this.response.indexName,
    //   headerList, resp ? resp.chartData.chartSeries.data : []);
    const fileName = this.getFileName(currentTimeSeries);
    const URL = this.apiService.createGetPath('/indices/createExcel', ['fileName', encodeURIComponent(fileName)]);
    window.open(URL);
    // this.utilService.downloadFile(dataToExport, fileName);
  }


  closeAlert(alert: string): void {
    switch (alert) {
      case 'alert1':
        this.showAlert1 = false;
        break;
      case 'alert2':
        this.showAlert2 = false;
        break;
      case 'alert3':
        this.showAlert3 = false;
        break;
      case 'indexNotFoundMsg':
        this.indexNotInHeadline = false;
        this.route.navigateByUrl('Carbon/Home');
        break;
    }
  }

  getTrimmedPeriodValue(period: string): string {
    switch (period) {
      case '1 Month':
        return '1M';
      case '3 Months':
        return '3M';
      case '6 Months':
        return '6M';
      case '1 Year':
        return '1Y';
      case '2 Years':
        return '2Y';
      case '5 Years':
        return '5Y';
      case '10 Years':
        return '10Y';
      case 'Max':
        return 'Max';
      case 'YTD':
        return 'YTD';
    }
    return '';
  }

  getFileName(currentTimeSeries: string): string{
    return encodeURIComponent(this.response.indexName + '_' + this.currentPeriod + '_' + currentTimeSeries);
  }
}
